import React, { useState } from 'react';
import { uploadImage, STORAGE_PATHS } from '../../services/firebase-storage.js';
import { API } from '../../utils/database-frontend.js';

const ProductForm = ({ onSuccess, onError }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    image: null
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      image: e.target.files[0]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.title || !formData.description || !formData.image) {
      onError('❌ Lütfen tüm alanları doldurun');
      return;
    }

    setLoading(true);
    
    try {
      // Upload image to Firebase Storage
      const uploadResult = await uploadImage(
        formData.image,
        STORAGE_PATHS.PRODUCTS,
        `product-${Date.now()}.${formData.image.name.split('.').pop()}`
      );

      // Add to PostgreSQL database
      const productData = {
        Title: formData.title,
        Description: formData.description,
        ImageUrl: uploadResult.url,
        FirebaseImagePath: uploadResult.path
      };

      console.log('Sending product data to backend:', productData);
      const result = await API.products.create(productData);
      console.log('Backend response:', result);
      
      onSuccess('✅ Ürün başarıyla eklendi!');
      
      // Reset form
      setFormData({
        title: '',
        description: '',
        image: null
      });
      
      // Reset file input
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = '';
      
    } catch (error) {
      onError('❌ Ürün eklenirken hata oluştu: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">📦 Yeni Ürün Ekle</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Ürün Başlığı
          </label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleInputChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Örn: C25/30 Hazır Beton"
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Ürün Açıklaması
          </label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            rows="4"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Ürün hakkında detaylı açıklama..."
            required
          />
        </div>
        
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Ürün Görseli
          </label>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            required
          />
          {formData.image && (
            <p className="mt-2 text-sm text-gray-600">
              Seçilen dosya: {formData.image.name}
            </p>
          )}
        </div>
        
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition duration-300"
        >
          {loading ? '⏳ Ekleniyor...' : '✅ Ürün Ekle'}
        </button>
      </form>
    </div>
  );
};

export default ProductForm; 